<template>
  <v-dialog v-model="dialogOrder" max-width="1200px">
    <template v-slot:activator="{ on, attrs }">
      <v-card min-height="300px" class="d-flex flex-column">
        <v-card-title
          class="px-2 py-2"
          :class="[
            { 'purple lighten-3': sessionSlot.isEvent },
            { 'blue lighten-3': sessionSlot.isFree },
            { 'yellow lighten-3': sessionSlot.isPending },
            { 'red lighten-3': sessionSlot.isNotPaid },
            { 'orange lighten-3': sessionSlot.isNeedPaid },
            { 'green lighten-3': sessionSlot.isPaid },
            {
              'grey lighten-3':
                sessionSlot.orders.length && sessionSlot.isArchived,
            },
          ]"
        >
          {{ sessionSlot.time_start }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.stop="dialogForm = true"
            v-if="sessionSlot.available_persons > 0"
          >
            <v-icon>mdi-plus-circle</v-icon>
          </v-btn>
          <booking-admin-form
            v-if="!sessionSlot.isArchived"
            :sessionSlot="sessionSlot"
            :selectedDay="selectedDay"
            :dialogForm="dialogForm"
            @close-dialog="closeDialog"
            @visible-alert="visibleAlert"
            @close-form="dialogForm = false"
            @reload-schedule="emitingOrderManipulation"
            @reload-summary="emitingOrderManipulation(formattedDate)"
          ></booking-admin-form>
          <v-icon v-if="sessionSlot.orders.length && sessionSlot.isArchived"
            >mdi-archive</v-icon
          >
        </v-card-title>
        <v-card-text
          class="px-2 pb-2"
          v-if="sessionSlot.orders.length"
          v-bind="attrs"
          v-on="on"
        >
          <v-card v-for="(order, k) in sessionSlot.orders" :key="k">
            <v-list dense class="py-0">
              <v-list-item class="px-2 mt-2">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon dense>mdi-identifier</v-icon>
                    {{ order.id + ", " + order.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    class="purple--text pl-1"
                    v-if="order.order_type == 4"
                    v-html="$t('BAFormEvent')"
                  ></v-list-item-subtitle>
                  <v-list-item-subtitle
                    class="blue--text pl-1"
                    v-if="order.order_type == 3"
                    v-html="$t('BAItemFree')"
                  ></v-list-item-subtitle>
                  <v-list-item-subtitle
                    class="blue--text pl-1"
                    v-else-if="order.order_type == 2"
                    v-html="$t('BAItemTech')"
                  ></v-list-item-subtitle>
                  <v-list-item-subtitle
                    class="green--text pl-1"
                    v-else-if="order.status == 6"
                    v-html="$t('BAItemPayed') + convertPrice(order.paid)"
                  ></v-list-item-subtitle>
                  <v-list-item-subtitle
                    class="red--text pl-1"
                    v-else-if="order.paid == 0"
                    v-html="
                      $t('BAItemNotPayed') + convertPrice(order.need_paid)
                    "
                  ></v-list-item-subtitle>
                  <v-list-item-subtitle
                    class="red--text pl-1"
                    v-else-if="order.status == 4"
                    v-html="$t('BAItemCancelled')"
                  ></v-list-item-subtitle>
                  <v-list-item-subtitle
                    class="orange--text pl-1"
                    v-else
                    v-html="
                      $t('BAItemToPay') +
                      ' ' +
                      convertPrice(order.purchase - order.paid)
                    "
                  ></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="mb-2">
                  <v-spacer></v-spacer>
                  <v-list-item-action-text>
                    <v-icon dense>mdi-account-multiple</v-icon>
                    <span>{{ " " + order.persons }}</span>
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-card-text>
        <v-card-text
          v-else
          class="d-flex flex-grow-1 flex-column justify-center"
        >
          <p class="text-center">{{ $t("BAItemNoSession") }}</p>
        </v-card-text>
      </v-card>
      <OrderInformationModal
        :alert="alert"
        @close-alert="alert = false"
      ></OrderInformationModal>
    </template>

    <v-card tile style="min-height: 415px">
      <v-container class="py-3">
        <booking-admin-order
          v-for="(order, k) in sessionSlot.orders"
          :key="k"
          :order="order"
          :sessionSlot="sessionSlot"
          :selectedDay="selectedDay"
          @change-order="emitingOrderManipulation"
          @remove-order="emitingOrderManipulation"
          @pay-order="emitingOrderManipulation"
        ></booking-admin-order>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import BookingAdminForm from "@/components/BookingAdminForm.vue";
import BookingAdminOrder from "@/components/BookingAdminOrder.vue";
import OrderInformationModal from "@/components/OrderInformationModal";
import { mapGetters } from "vuex";

export default {
  name: "BookingAdminItem",

  props: ["sessionSlot", "selectedDay"],

  data() {
    return {
      dialogOrder: false,
      dialogForm: false,
      alert: false,
    };
  },

  computed: {
    ...mapGetters(["orderId"]),
    formattedDate() {
      return this.sessionSlot
        ? this.moment(this.sessionSlot.begin).format("DD.MM.YYYY")
        : "";
    },
  },

  components: {
    BookingAdminForm,
    BookingAdminOrder,
    OrderInformationModal,
  },

  methods: {
    convertPrice(value) {
      let currency = this.sessionSlot.pricing.currency;
      let price = new Intl.NumberFormat(
        navigator.language.split("-")[0]
      ).format(value);

      if (currency.is_before) {
        return currency.code + currency.blank_place + price;
      } else {
        return price + currency.blank_place + currency.code;
      }
    },
    emitingOrderManipulation() {
      this.dialogOrder = false;
      this.$emit("reload-schedule", this.sessionSlot.begin);
    },
    visibleAlert() {
      this.alert = true;
    },
    closeDialog() {
      if (this.orderId !== null) {
        this.dialogForm = false;
      }
    },
  },
};
</script>
